import StyledButton from "../../common/buttons/StyledButton";
import TextButton from "../../common/buttons/TextButton";
import BaseModal from "../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../common/modals/ModalCloseButton/ModalCloseButton";
import styles from "./CMInfoConfirmationModal.module.css";

const strings = {
  reset: {
    title: "Confirm Reset",
    body: "A_0229 - You have made updates to a CM Information section that has not been updated to the account. Do you want to discard the updated information and end this process?",
  },
  clear: {
    title: "Confirm Clear",
    body: "A_0231 - Are you sure you would like to clear all data from the page?",
  },
  ok: "Ok",
  cancel: "Cancel",
};

type Props = {
  isOpen: boolean;
  variant: "reset" | "clear" | undefined;
  onSuccess: () => void;
  onRequestClose: () => void;
};

export default function CMInfoConfirmationModal({
  isOpen,
  variant,
  onSuccess,
  onRequestClose,
}: Props) {
  return (
    <BaseModal
      className={styles.modal}
      label={variant ? strings[variant].title : ""}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div className={styles.header}>
        <div className={styles.title}>
          {variant ? strings[variant].title : ""}
        </div>
        <ModalCloseButton onClick={onRequestClose} />
      </div>
      <div className={styles.body}>{variant ? strings[variant].body : ""}</div>
      <div className={styles.footer}>
        <StyledButton className={styles.okButton} onClick={onSuccess}>
          {strings.ok}
        </StyledButton>
        <TextButton onClick={onRequestClose}>{strings.cancel}</TextButton>
      </div>
    </BaseModal>
  );
}
